<template>
  <div>
    <ValidationObserver ref="form" v-slot="{ valid }" tag="form">
      <div class="p-box">
        <div class="p-box__body">
          <Info>{{ $t('messages.qualityCheckDescription') }}</Info>
          <Loading v-if="loading" />
          <div v-else class="urlForm">
            <div class="p-formGrid">
              <div class="p-formGrid__items">
                <template
                  v-for="(url,key) in urls"
                >
                  <!-- eslint-disable-next-line vue/require-v-for-key -->
                  <fieldset
                    class="p-formGrid__item p-formGrid__item__s__6 p-formGrid__item__m__6 p-formGrid__item__l__6"
                  >
                    <label class="c-formLabel">
                      {{ $t('pages.CompaniesLocationStoreAttributesMultipleUrlEdit.link') }}
                    </label>
                    <ValidationProvider v-slot="{ value, handleChange, errors }" :key="'url_validation_' + key" v-model="urls[key]" :name="`url_${key}`" rules="url">
                      <input
                        :value="value"
                        :placeholder="$t('labels.placeholder.basic')"
                        class="c-textField"
                        @input="handleChange"
                      >
                      <ValidationError :error="errors[0]" />
                    </ValidationProvider>
                  </fieldset>
                  <!-- eslint-disable-next-line vue/require-v-for-key -->
                  <div class="c-button--left">
                    <button v-if="urls.length > 1"
                            class="c-button__item removeBtn"
                            @click="removeUrl(key)"
                    >
                      <Icon name="iconCross" class="c-button__icon" />
                      {{ $t('labels.delete') }}
                    </button>
                  </div>
                </template>
              </div>
            </div>
            <div class="c-button c-button--icon">
              <div v-show="showAddUrlBtn" class="c-button__item c-button__item--primary" @click="addUrls">
                <Icon name="iconPlusRed" class="c-button__icon" />
                <span>{{ $t('labels.add', { value: $t('pages.CompaniesLocationStoreAttributesUrlEdit.addLink') }) }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="p-box__footer">
          <div class="buttonGroup">
            <KkButton
              color="secondary"
              :text="$t('labels.cancel')"
              class="buttonGroup__item"
              :to="{ name: 'CompaniesLocationStore', params: { company_uuid: companyUuid, store_uuid: storeUuid }}"
            />
            <KkButton
              color="primary"
              :text="$t('labels.save')"
              :disabled="!valid"
              class="buttonGroup__item"
              @click.prevent="handleSubmit"
            />
          </div>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import Info from '../../../../../components/Info'
import ValidationError from '../../../../../components/ValidationError'
import Icon from '../../../../../components/Icon'
import Loading from '../../../../../components/Loading'
import { KkButton } from '../../../../../components/base'

export default {
  name: 'CompaniesLocationStoreAttributesMultipleUrlEdit',
  components: {
    Loading,
    Info,
    ValidationError,
    Icon,
    KkButton
  },
  emits: ['update-title', 'update-breadcrumbs'],
  data() {
    return {
      urls: ['']
    }
  },
  computed: {
    ...mapState({
      store: state => state.companiesLocationStore.data,
      attributes: state => state.companiesStoreGmbAttributes.attributes,
      loading: state => state.companiesStoreGmbAttributes.loading,
    }),
    ...mapGetters({
      urlGroupDataFlattenList: 'companiesStoreGmbAttributes/urlGroupDataFlattenList',
    }),
    attributeId() {
      return this.$route.params.attribute_id
    },
    companyUuid() {
      return this.$route.params.company_uuid
    },
    storeUuid() {
      return this.$route.params.store_uuid
    },
    /**
     * @return { groupData }
     */
    attribute() {
      return this.urlGroupDataFlattenList.find(v => v.parent === this.attributeId)
    },
    showAddUrlBtn() {
      return this.urls.length < 10
    }
  },
  async created() {
    await Promise.all([
      this.readStore({ company_uuid: this.companyUuid, store_uuid: this.storeUuid }),
      this.readGmbAttributes()
    ])
    if (this.attribute.uriValues) {
      this.urls = this.attribute.uriValues.map(v => v.uri)
    }
    this.$emit(
      'update-title',
      this.$t('pages.CompaniesLocationStoreAttributesMultipleUrlEdit.title', {
        name: this.store.attributes.name,
        url: this.attribute?.displayName
      })
    )
    const breadcrumbs = [
      {
        name: this.$t('pages.CompaniesDashboards.title'),
        pathName: 'CompaniesDashboards',
        query: {},
      },
      {
        name: this.$t('pages.CompaniesLocationStores.title'),
        pathName: 'CompaniesLocationStores',
        query: {},
      },
      {
        name: this.$t('pages.CompaniesLocationStore.basicTitle'),
        pathName: 'CompaniesLocationStore',
        query: {},
      },
    ]
    breadcrumbs.push({
      name: this.$t('pages.CompaniesLocationStoreAttributesMultipleUrlEdit.titleForBreadcrumb', { url: this.attribute?.displayName })
    })
    this.$emit('update-breadcrumbs', breadcrumbs)
  },
  methods: {
    ...mapActions({
      readStore: 'companiesLocationStore/readStore',
      readGmbAttributes: 'companiesStoreGmbAttributes/readGmbAttributes',
      changeAttribute: 'companiesStoreGmbAttributes/reduceAttribute',
      updateGmbAttribute: 'companiesStoreGmbAttributes/updateGmbAttribute'
    }),
    addUrls() {
      if (this.showAddUrlBtn) {
        this.urls.push('')
      }
    },
    async handleSubmit() {
      const result = await this.$refs.form.validate()
      if (!result) return

      const filteredUrls = this.urls.filter(url => url !== '')

      // 重複を排除
      const set = new Set(filteredUrls)
      if (Array.from(set).length !== filteredUrls.length) {
        alert(this.$t('pages.CompaniesLocationStoreAttributesMultipleUrlEdit.uniqueError'))
        return
      }

      await this.changeAttribute({
        type: this.attribute.valueType,
        payload: {
          uriValues: filteredUrls.map(v => {
            return {
              uri: v
            }
          }),
          metadata: this.attribute
        }
      })
      this.updateGmbAttribute(this.attributes)
    },
    removeUrl(key) {
      this.urls.splice(key, 1)
    }
  }
}
</script>

<style lang="scss" scoped>
.urlForm {
  padding: 28px 32px;
  border: 1px solid #E4E7EB;
  border-radius: 4px;
}
.removeBtn {
  margin-top: 21px;
  font-weight: normal;
}
.buttonGroup {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  &__item {
    flex-grow: 0;
  }
}
</style>
